export default () => ({
    queryString: '',
    submitWasClicked: false,

    get fieldIsEmpty() {
        return this.queryString.length == 0;
    },

    get showError() {
        return this.fieldIsEmpty && this.submitWasClicked;
    },

    onSubmit(event) {
        // console.log( 'onSubmit', { event } );
        if ( this.fieldIsEmpty ) {
            event.preventDefault();
            this.submitWasClicked = true;
        }
    }
});
